import "./assets/css/common.css";
import Router from "./_constants/Router";

const App = () => {
  return <Router />;
};

export default App;
